<template>
   <Toaster />
</template>

<script lang="ts" setup>
import { Toaster } from 'vue-sonner'
</script>
